import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as SelectMui,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
}));

/**
 * @param {{name:string,label:string, value:Number, onChange:()=>void, options:Array}} props
 */

export default function Select({ name, label, value, onChange, options }) {
  const classes = useStyles();
  return (
    <FormControl className={classes.formControl} variant="outlined">
      <InputLabel>{label}</InputLabel>
      <SelectMui label={label} name={name} value={value} onChange={onChange}>
        {options.map((item) => (
          <MenuItem key={item.id} value={item.value}>
            {item.title}
          </MenuItem>
        ))}
      </SelectMui>
    </FormControl>
  );
}
